import React from "react";
import Heroes from "../Components/Heroes";
import LetsOrder from "../Components/LetsOrder";
export default function LandingPage() {

    return (
    <>
     
      <Heroes />
      <LetsOrder />
      
    </>
  );
}
